import CONSTANTS from 'core/data-model/constants/values'
import { getPartnerAvailableDisplayProduct } from 'quick-quote/selectors/partner-selector'

/**
 * createProductTermLifeFunc
 */
export function createProductTermLifeService() {
  function getSelectableProductUltimateGrowth(state) {
    const availableDisplayProducts = getPartnerAvailableDisplayProduct(state)
    return CONSTANTS.ULTIMATE_GROWTH_CODE_GROUP.filter((code) => availableDisplayProducts[code][0])
  }

  return {
    getSelectableProductUltimateGrowth,
  }
}
